import { Button, Modal } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';
import ModalInactive from './ModalInactive';

const ModalCheck = ({
    open,
    text = 'Lorem ipsum dolor sit amet',
    handelClose,
    handelOk,
    loading,
    width = 135,
    isConfirm = true,
    confirmText = null,
    cancelText = null,
    workflow,
}) => {
    const { t } = useTranslation();
    const [openConfirm, setOpenConfirm] = useState(false);

    return (
        <>
            <Modal
                width={450}
                className="_modal"
                footer={false}
                open={open}
                onCancel={handelClose}
            >
                <div className="flex flex-col space-y-4 justify-center items-center py-6 text-center">
                    {ImgCheck}
                    <div className="text-[22px] font-normal whitespace-pre-line">
                        {t('This inactive workflow has resulted in')}
                        <div>
                            {t('My Task arising from the request of')}
                            <span> “{workflow?.dsTypeName}” </span>
                        </div>
                        {t(
                            'will not be able to work according to the workflow'
                        )}
                    </div>
                    <div className="whitespace-pre-line text-[#65707A] py-1">
                        {parse(text)}
                    </div>
                </div>
                <div className="flex justify-center items-center space-x-4 my-4">
                    {isConfirm ? (
                        <>
                            <Button
                                style={{ width }}
                                type="primary"
                                onClick={handelClose}
                                size="large"
                                ghost
                            >
                                {cancelText ? cancelText : t('common.Cancel')}
                            </Button>
                            <Button
                                style={{ width }}
                                loading={loading}
                                onClick={() => {
                                    // handelOk();
                                    handelClose();
                                    setOpenConfirm(true);
                                }}
                                size="large"
                                type="primary"
                            >
                                {confirmText
                                    ? confirmText
                                    : t('common.Confirm')}
                            </Button>
                        </>
                    ) : (
                        <Button
                            onClick={handelOk}
                            className="px-6"
                            size="large"
                            type="primary"
                        >
                            {t('common.Close')}
                        </Button>
                    )}
                </div>
            </Modal>

            <ModalInactive
                loading={loading}
                open={openConfirm}
                handelOk={() => {
                    setOpenConfirm(false);
                }}
                handelClose={() => {
                    setOpenConfirm(false);
                }}
                workflow={workflow}
            />
        </>
    );
};
export default ModalCheck;

const ImgCheck = (
    <svg
        width="220"
        height="120"
        viewBox="0 0 220 120"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_846_180516)">
            <path
                d="M153.893 15.7178C153.514 12.949 153.039 9.97632 151.079 7.97761C150.457 7.34342 149.713 6.84128 148.891 6.50146C148.068 6.16164 147.186 5.99118 146.296 6.00035C145.406 6.00953 144.527 6.19815 143.712 6.55485C142.898 6.91155 142.164 7.42893 141.555 8.07581C140.128 9.5923 139.498 11.7217 139.44 13.7995C139.383 15.8772 139.847 17.932 140.363 19.9462C143.089 20.0004 145.796 19.4697 148.299 18.3899C148.912 18.0916 149.549 17.8427 150.202 17.6456C150.863 17.4779 151.334 17.8999 151.949 18.194L152.287 17.55C152.563 18.0624 153.419 17.9105 153.73 17.4178C154.04 16.9251 153.972 16.2941 153.893 15.7178Z"
                fill="#2F2E41"
            />
            <path
                d="M142.503 27.4081L143.293 23.3898L137.373 20.8364L126.789 15.7849C126.715 15.3161 126.5 14.8807 126.173 14.5363C125.845 14.1919 125.42 13.9546 124.954 13.8559C124.489 13.7572 124.004 13.8018 123.564 13.9836C123.124 14.1655 122.75 14.4761 122.491 14.8744C122.232 15.2727 122.101 15.7398 122.114 16.2141C122.128 16.6884 122.285 17.1474 122.566 17.5305C122.847 17.9135 123.239 18.2025 123.688 18.3593C124.138 18.5161 124.624 18.5332 125.084 18.4084L135.161 24.6042L142.503 27.4081Z"
                fill="#FFB8B8"
            />
            <path
                d="M138.529 26.7282L142.817 22.3613L142.902 22.387C142.955 22.4031 148.283 24.0212 151.679 25.6654C152.063 25.8371 152.405 26.0901 152.68 26.4068C152.956 26.7236 153.159 27.0964 153.275 27.4993C153.444 28.0634 153.444 28.6645 153.275 29.2286C153.106 29.7928 152.775 30.2955 152.323 30.675C151.859 31.0891 151.285 31.3613 150.669 31.4589C150.053 31.5566 149.423 31.4755 148.852 31.2255L138.529 26.7282Z"
                fill="#7B67FB"
            />
            <path
                d="M138.516 45.9274L150.573 49.1372L153.008 37.7896L141.941 34.377L138.516 45.9274Z"
                fill="#FFB8B8"
            />
            <path
                d="M151.922 42.8474L140.144 40.1488L137.888 34.7027C137.705 33.9253 137.749 33.1118 138.017 32.3589C138.284 31.606 138.763 30.9456 139.397 30.4562L143.7 26.8366L146.007 23.9006L145.756 22.3447C145.711 22.0337 145.776 21.7169 145.941 21.449C146.106 21.181 146.359 20.9788 146.658 20.8772L149.732 19.7788C150.072 19.6521 150.448 19.6589 150.783 19.7977C151.118 19.9366 151.387 20.197 151.537 20.5264L151.863 21.2777C151.863 21.2777 153.253 21.9295 154.037 22.2961C154.44 22.4788 154.8 22.7443 155.094 23.0753C155.387 23.4062 155.607 23.7952 155.739 24.2166C156.938 28.0794 156.615 32.2525 154.834 35.8861L151.922 42.8474Z"
                fill="#7B67FB"
            />
            <path
                d="M47.1734 100.66L41.4784 99.1413C40.641 96.1717 40.5439 93.0433 41.1956 90.0278C43.6801 94.9208 50.3529 95.8434 54.3058 99.659C55.5296 100.858 56.4667 102.317 57.0478 103.926C57.6288 105.536 57.8389 107.255 57.6625 108.956L59.0267 112.893C56.2576 112.784 53.5451 112.078 51.0761 110.824C48.6072 109.57 46.4405 107.798 44.7253 105.629C43.7752 104.403 42.9839 103.063 42.37 101.64C44.753 101.292 47.1734 100.66 47.1734 100.66Z"
                fill="#F2F2F2"
            />
            <path
                d="M117.925 114H62.1072C60.6113 113.998 59.1771 113.406 58.1193 112.352C57.0615 111.298 56.4665 109.869 56.4648 108.379V34.7458C56.4665 33.2554 57.0615 31.8266 58.1193 30.7728C59.1771 29.719 60.6113 29.1262 62.1072 29.1245H117.925C119.421 29.1262 120.856 29.719 121.913 30.7728C122.971 31.8266 123.566 33.2554 123.568 34.7458V108.379C123.566 109.869 122.971 111.298 121.913 112.352C120.856 113.406 119.421 113.998 117.925 114Z"
                fill="#E6E6E6"
            />
            <path
                d="M96.6225 109.442H66.032C64.6699 109.441 63.3641 108.901 62.401 107.941C61.4378 106.982 60.8961 105.681 60.8945 104.324V38.8004C60.8961 37.4434 61.4378 36.1425 62.401 35.1829C63.3641 34.2234 64.67 33.6837 66.032 33.6821H114.003C115.365 33.6837 116.671 34.2234 117.634 35.1829C118.597 36.1425 119.139 37.4434 119.141 38.8004V87.0084C119.134 92.9562 116.759 98.6584 112.538 102.864C108.316 107.07 102.593 109.436 96.6225 109.442Z"
                fill="white"
            />
            <path
                d="M109.217 46.2614H70.8164C70.652 46.2617 70.4891 46.2296 70.337 46.1671C70.185 46.1046 70.0468 46.0128 69.9304 45.8971C69.814 45.7814 69.7216 45.644 69.6584 45.4927C69.5953 45.3414 69.5627 45.1792 69.5625 45.0153C69.5623 44.8515 69.5945 44.6892 69.6572 44.5378C69.72 44.3863 69.8121 44.2487 69.9282 44.1326C70.0443 44.0166 70.1823 43.9246 70.3342 43.8617C70.486 43.7988 70.6488 43.7663 70.8133 43.7661H109.217C109.549 43.7657 109.867 43.8968 110.103 44.1304C110.338 44.3641 110.47 44.6813 110.471 45.0122C110.471 45.3431 110.339 45.6606 110.105 45.8949C109.87 46.1292 109.552 46.261 109.22 46.2614H109.217Z"
                fill="#65707A"
            />
            <path
                d="M109.217 51.1918H70.8169C70.4847 51.1918 70.1662 51.0603 69.9313 50.8263C69.6964 50.5923 69.5645 50.2749 69.5645 49.944C69.5645 49.6131 69.6964 49.2957 69.9313 49.0617C70.1662 48.8277 70.4847 48.6963 70.8169 48.6963H109.217C109.549 48.6963 109.868 48.8277 110.103 49.0617C110.338 49.2957 110.469 49.6131 110.469 49.944C110.469 50.2749 110.338 50.5923 110.103 50.8263C109.868 51.0603 109.549 51.1918 109.217 51.1918Z"
                fill="#65707A"
            />
            <path
                d="M87.4624 56.1219H70.8169C70.4847 56.1219 70.1662 55.9905 69.9313 55.7565C69.6964 55.5225 69.5645 55.2051 69.5645 54.8742C69.5645 54.5433 69.6964 54.2259 69.9313 53.9919C70.1662 53.7579 70.4847 53.6265 70.8169 53.6265H87.4624C87.7946 53.6265 88.1132 53.7579 88.348 53.9919C88.5829 54.2259 88.7149 54.5433 88.7149 54.8742C88.7149 55.2051 88.5829 55.5225 88.348 55.7565C88.1132 55.9905 87.7946 56.1219 87.4624 56.1219Z"
                fill="#65707A"
            />
            <path
                d="M109.217 66.4475H70.8164C70.4843 66.4479 70.1656 66.3168 69.9304 66.0832C69.6953 65.8495 69.5629 65.5323 69.5625 65.2014C69.5621 64.8705 69.6936 64.553 69.9282 64.3187C70.1628 64.0844 70.4811 63.9526 70.8133 63.9521H109.217C109.549 63.9517 109.867 64.0828 110.103 64.3165C110.338 64.5502 110.47 64.8674 110.471 65.1983C110.471 65.5292 110.339 65.8467 110.105 66.081C109.87 66.3152 109.552 66.4471 109.22 66.4475H109.217Z"
                fill="#E4E4E4"
            />
            <path
                d="M109.217 71.3778H70.8169C70.4847 71.3778 70.1662 71.2463 69.9313 71.0123C69.6964 70.7783 69.5645 70.461 69.5645 70.1301C69.5645 69.7991 69.6964 69.4818 69.9313 69.2478C70.1662 69.0138 70.4847 68.8823 70.8169 68.8823H109.217C109.549 68.8823 109.868 69.0138 110.103 69.2478C110.338 69.4818 110.469 69.7991 110.469 70.1301C110.469 70.461 110.338 70.7783 110.103 71.0123C109.868 71.2463 109.549 71.3778 109.217 71.3778Z"
                fill="#E4E4E4"
            />
            <path
                d="M87.4624 76.308H70.8169C70.4847 76.308 70.1662 76.1765 69.9313 75.9425C69.6964 75.7085 69.5645 75.3912 69.5645 75.0602C69.5645 74.7293 69.6964 74.4119 69.9313 74.178C70.1662 73.944 70.4847 73.8125 70.8169 73.8125H87.4624C87.7946 73.8125 88.1132 73.944 88.348 74.178C88.5829 74.4119 88.7149 74.7293 88.7149 75.0602C88.7149 75.3912 88.5829 75.7085 88.348 75.9425C88.1132 76.1765 87.7946 76.308 87.4624 76.308Z"
                fill="#E4E4E4"
            />
            <path
                d="M109.217 86.6335H70.8164C70.4843 86.6339 70.1656 86.5029 69.9304 86.2692C69.6953 86.0355 69.5629 85.7183 69.5625 85.3874C69.5621 85.0565 69.6936 84.739 69.9282 84.5047C70.1628 84.2704 70.4811 84.1386 70.8133 84.1382H109.217C109.549 84.1378 109.867 84.2688 110.103 84.5025C110.338 84.7362 110.47 85.0534 110.471 85.3843C110.471 85.7152 110.339 86.0327 110.105 86.267C109.87 86.5013 109.552 86.6331 109.22 86.6335H109.217Z"
                fill="#E4E4E4"
            />
            <path
                d="M109.217 91.5633H70.8169C70.4847 91.5633 70.1662 91.4319 69.9313 91.1979C69.6964 90.9639 69.5645 90.6465 69.5645 90.3156C69.5645 89.9847 69.6964 89.6673 69.9313 89.4333C70.1662 89.1993 70.4847 89.0679 70.8169 89.0679H109.217C109.549 89.0679 109.868 89.1993 110.103 89.4333C110.338 89.6673 110.469 89.9847 110.469 90.3156C110.469 90.6465 110.338 90.9639 110.103 91.1979C109.868 91.4319 109.549 91.5633 109.217 91.5633Z"
                fill="#E4E4E4"
            />
            <path
                d="M87.462 96.4935H70.8164C70.4847 96.4929 70.1667 96.3611 69.9324 96.1272C69.698 95.8933 69.5664 95.5763 69.5664 95.2458C69.5664 94.9153 69.698 94.5983 69.9324 94.3643C70.1667 94.1304 70.4847 93.9987 70.8164 93.998H87.462C87.7937 93.9987 88.1117 94.1304 88.346 94.3643C88.5804 94.5983 88.712 94.9153 88.712 95.2458C88.712 95.5763 88.5804 95.8933 88.346 96.1272C88.1117 96.3611 87.7937 96.4929 87.462 96.4935Z"
                fill="#E4E4E4"
            />
            <path
                d="M143.197 37.4571L140.688 31.8835L140.742 31.8143C140.777 31.7709 144.238 27.4236 147.017 24.8766C147.318 24.5835 147.679 24.3594 148.076 24.2198C148.473 24.0801 148.895 24.0284 149.314 24.0682C149.903 24.1181 150.464 24.3382 150.929 24.7014C151.394 25.0645 151.743 25.555 151.932 26.1127C152.149 26.6948 152.193 27.3268 152.059 27.9332C151.925 28.5396 151.619 29.0948 151.176 29.5322L143.197 37.4571Z"
                fill="#7B67FB"
            />
            <path
                d="M145.464 19.1373C148.472 19.1373 150.911 16.7079 150.911 13.711C150.911 10.7141 148.472 8.28467 145.464 8.28467C142.456 8.28467 140.018 10.7141 140.018 13.711C140.018 16.7079 142.456 19.1373 145.464 19.1373Z"
                fill="#FFB8B8"
            />
            <path
                d="M137.003 110.113H134.751L133.68 101.461H137.003V110.113Z"
                fill="#FFB8B8"
            />
            <path
                d="M138.191 114H136.577L136.288 112.481L135.55 114H131.267C131.062 114 130.862 113.934 130.697 113.813C130.532 113.692 130.409 113.521 130.348 113.326C130.287 113.131 130.29 112.921 130.357 112.728C130.424 112.535 130.551 112.368 130.72 112.251L134.14 109.898V108.363L137.738 108.577L138.191 114Z"
                fill="#2F2E41"
            />
            <path
                d="M165.224 108.207L163.132 109.037L158.924 101.393L162.012 100.168L165.224 108.207Z"
                fill="#FFB8B8"
            />
            <path
                d="M167.771 111.381L166.271 111.976L165.439 110.671L165.317 112.354L161.338 113.932C161.148 114.008 160.938 114.021 160.739 113.969C160.54 113.917 160.364 113.804 160.234 113.645C160.105 113.486 160.03 113.29 160.021 113.086C160.011 112.881 160.067 112.679 160.181 112.509L162.485 109.063L161.915 107.636L165.337 106.509L167.771 111.381Z"
                fill="#2F2E41"
            />
            <path
                d="M137.87 106.138H133.213L134.5 84.3382L133.559 69.5615L133.561 69.5497L137.071 48.3681C137.347 46.6978 138.093 45.1398 139.222 43.8751L139.265 43.8271L151.01 46.7171L152.191 49.3997C156.223 51.7891 157.497 65.2625 157.549 65.8364L159.256 82.6326L163.432 103.218L160.492 104.795L160.442 104.698L151.158 86.3058L145.295 66.9102L141.541 84.3666L137.87 106.138Z"
                fill="#2F2E41"
            />
            <path
                d="M152.211 13.9665C152.018 12.7052 151.816 11.4333 151.364 10.2457C150.911 9.05803 150.181 7.94563 149.134 7.27284C147.476 6.20766 145.33 6.4131 143.472 7.02582C142.034 7.49967 140.631 8.21989 139.618 9.37776C138.604 10.5356 138.035 12.1878 138.412 13.7018C140.394 13.2351 142.377 12.7685 144.359 12.3018L144.142 12.4546C144.793 12.778 145.362 13.2448 145.805 13.8198C146.247 14.3947 146.553 15.0626 146.698 15.7727C146.84 16.4914 146.819 17.2326 146.638 17.9425C146.457 18.6525 146.12 19.3135 145.651 19.8777C147.003 19.3998 148.355 18.922 149.707 18.4442C150.542 18.1492 151.435 17.8094 151.93 17.0529C152.504 16.1758 152.371 15.0132 152.211 13.9665Z"
                fill="#2F2E41"
            />
            <path
                d="M36.2855 113.948H185.714C185.79 113.948 185.863 113.918 185.916 113.865C185.97 113.811 186 113.739 186 113.663C186 113.588 185.97 113.516 185.916 113.462C185.863 113.409 185.79 113.379 185.714 113.379H36.2855C36.2098 113.379 36.1372 113.409 36.0836 113.462C36.0301 113.516 36 113.588 36 113.663C36 113.739 36.0301 113.811 36.0836 113.865C36.1372 113.918 36.2098 113.948 36.2855 113.948Z"
                fill="#CCCCCC"
            />
            <path
                d="M101.892 46.2941H135.688C136.015 46.2924 136.335 46.2058 136.619 46.0428C136.902 45.8799 137.139 45.6461 137.306 45.3642C137.472 45.0823 137.564 44.7619 137.571 44.4341C137.578 44.1063 137.5 43.7823 137.345 43.4935L120.455 11.9988C120.293 11.6969 120.053 11.4446 119.76 11.2687C119.467 11.0929 119.131 11 118.79 11C118.448 11 118.113 11.0929 117.82 11.2687C117.526 11.4446 117.286 11.6969 117.124 11.9988L100.226 43.4935C100.071 43.7829 99.9932 44.1077 100 44.4362C100.008 44.7647 100.1 45.0856 100.268 45.3678C100.435 45.6499 100.673 45.8835 100.958 46.0459C101.242 46.2083 101.564 46.2938 101.892 46.2941ZM120.94 40.5391H116.639V36.2249H120.94V40.5391ZM120.94 33.3474H116.639V24.7169H120.94V33.3474Z"
                fill="#F9C153"
            />
            <path
                d="M145.286 34.0215L141.822 31.8188L137.27 36.3732L128.678 44.337C128.213 44.2339 127.728 44.2737 127.286 44.4514C126.844 44.629 126.467 44.936 126.205 45.3318C125.942 45.7275 125.806 46.1934 125.815 46.6678C125.824 47.1422 125.977 47.6027 126.254 47.9884C126.532 48.3742 126.92 48.6669 127.368 48.828C127.816 48.9891 128.302 49.0109 128.763 48.8905C129.224 48.7702 129.637 48.5133 129.948 48.1539C130.259 47.7946 130.453 47.3496 130.504 46.8779L139.98 39.8024L145.286 34.0215Z"
                fill="#FFB8B8"
            />
        </g>
        <defs>
            <clipPath id="clip0_846_180516">
                <rect
                    width="150"
                    height="108"
                    fill="white"
                    transform="translate(36 6)"
                />
            </clipPath>
        </defs>
    </svg>
);
